import React from 'react';

/**
 * Shared uppercase title row for Account Overview dashboard cards.
 */
export default function OverviewCardHeader({ title, colors, trailing, style }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        marginBottom: 8,
        flexShrink: 0,
        minWidth: 0,
        ...style,
      }}
    >
      <div
        style={{
          fontSize: 11,
          color: colors.textLight,
          fontWeight: 500,
          textTransform: 'uppercase',
          letterSpacing: '0.6px',
          flexShrink: 0,
        }}
      >
        {title}
      </div>
      {trailing || null}
    </div>
  );
}
